import Skeleton from '@trackman/web-shared-components/components/LoadingPlaceholder/Skeleton';
import './MastersAndPartnersCard.scss';
import Subtitle from 'components/TextComps/Subtitle';

export const MastersAndPartnersCard = ({
  id,
  name,
  imgUrl,
  description,
  customClasses,
  handleSetIsModalOpen,
}: {
  id: string;
  name: string;
  imgUrl: string;
  description: string;
  customClasses?: string;
  handleSetIsModalOpen?: () => void;
}) => {
  return (
    <div key={id} className={`masters-and-partners-card ${customClasses || ''}`} onClick={handleSetIsModalOpen}>
      <img src={imgUrl} alt={name} />
      <div className='masters-and-partners-card-info'>
        <Subtitle>
          <>{name}</>
        </Subtitle>
        <span className='masters-and-partners-card-description'>{description}</span>
      </div>
    </div>
  );
};

export const MastersAndPartnersLoadingCard = ({ id }: { id: string }) => {
  return (
    <div key={id} className='masters-and-partners-card'>
      <Skeleton variant='rectangular' width={100} height={100} />
      <div className='masters-and-partners-card-info'>
        <Skeleton variant='text' width={200} />
        <Skeleton variant='text' width={150} />
      </div>
    </div>
  );
};
